import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";

export const GATING_ANALYTICS_NAMESPACE = "s/gating";

export type GatingAnalyticsPayload = {
  source: string;
  feature: string;
  gatingType: string;
  isManaged: boolean;
};

export type GatingAnalyticsPayloadWithCta = GatingAnalyticsPayload & {
  ctaDestination: string;
};

export function logGatingShown<T extends GatingAnalyticsPayload>(payload: T) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${GATING_ANALYTICS_NAMESPACE}/shown`,
    payload
  });
}

export function logGatingDismiss<T extends GatingAnalyticsPayload>(payload: T) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${GATING_ANALYTICS_NAMESPACE}/dismiss`,
    payload
  });
}

export function logGatingCtaClicked<T extends GatingAnalyticsPayloadWithCta>(
  payload: T
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${GATING_ANALYTICS_NAMESPACE}/ctaClicked`,
    payload
  });
}
